import {
    ADD_NEW_SITE,
    ADD_NEW_SITE_ERROR,
    ADD_NEW_SITE_SUCCESS,
    UPDATE_NEW_SITE,
    UPDATE_NEW_SITE_ERROR,
    UPDATE_NEW_SITE_SUCCESS,
    DELETE_SITE_SUCCESS,
    DELETE_SITE_ERROR,
    DELETE_SITE_BYID,
    DRAWING_DATA_SUCCESS,
    DRAWING_DATA_ERROR,
    SITES_LIST_SUCCESS,
    BULK_UPLOAD,
    CHANGEREQUEST_BY_SITEID,CHANGEREQUEST_BY_SITEID_SUCCESS,CHANGEREQUEST_BY_SITEID_ERROR,
    ADD_CHANGEREQUEST,ADD_CHANGEREQUEST_SUCCESS,ADD_CHANGEREQUEST_ERROR,SITE_DATA_DROPDOWN,SITEDROPDOWN_LIST_SUCCESS
  } from "./actiontype";
  
  import {
    SITE_DATA,
    SITE_DATA_ERROR,
    SITE_DATA_SUCCESS,
    ALL_SITE_DATA_SUCCESS,
    DRAWING_DATA
  } from "./actiontype";
  
  export const getSitesListbyclientId = (params, download,exportname) => {
    return {
      type: SITE_DATA,
      payload: params,
      exports: download,
      exportname:exportname
    };
  };

  export const siteListByClientSuccess = (response) => {
    
    return {
      type: SITE_DATA_SUCCESS,
      payload: response,
    };
  };
  export const siteListSuccess = (response) => {
    return {
      type: SITES_LIST_SUCCESS,
      payload: response,
    };
  };
  
  export const fetchAllSites = () => {
    return {
      type: ALL_SITE_DATA_SUCCESS,
    };
  };
  export const getSitesDropdown = (params, download,exportname) => {
    return {
      type: SITE_DATA_DROPDOWN,
      payload: params,
      exports: download,
      exportname:exportname
    };
  };
  export const sitedropDownListSuccess = (response) => {
    return {
      type: SITEDROPDOWN_LIST_SUCCESS,
      payload: response,
    };
  };
  
  export const siteListError = (erordata) => {
    return {
      type: SITE_DATA_ERROR,
      payload: erordata,
    };
  };
  export const onAddnewSite = (params, callback) => {

    return {
      type: ADD_NEW_SITE,
      payload: params,
      callback,
    };
  };
  export const onAddnewSiteSuccess = (response) => {
   
    return {
      type: ADD_NEW_SITE_SUCCESS,
      payload: response,
    };
  };
  export const onAddnewSiteError = (erordata) => {
    return {
      type: ADD_NEW_SITE_ERROR,
      payload: erordata,
    };
  };
  export const onupdateSite = (params, callback) => { 
    return {
      type: UPDATE_NEW_SITE,
      payload: params,
      callback,
    };
  };
  export const onupdateSiteSuccess = (response) => {
    return {
      type: UPDATE_NEW_SITE_SUCCESS,
      payload: response,
    };
  };
  
  export const onupdateSiteError = (erordata) => {
    return {
      type: UPDATE_NEW_SITE_ERROR,
      payload: erordata,
    };
  };
  export const onDeletesite = (siteId, callback) => {
    return {
      type: DELETE_SITE_BYID,
      payload: siteId,
      callback,
    };
  };
  export const onDeletesiteSuccess = (mess) => {
    return {
      type: DELETE_SITE_SUCCESS,
      payload: mess,
    };
  };
  
  export const onDeletesiteError = (mess) => {
    return {
      type: DELETE_SITE_ERROR,
      payload: mess,
    };
  };
  export const postuploadData = (params, callback) => {
    return {
      type: BULK_UPLOAD,
      payload: params,
      callback,
    };
  };
  // export const postuploadDataSuccess = (response) => {
  //   return {
  //     type: BULK_UPLOAD_SUCCESS,
  //     payload: response,
  //   };
  // };
  // export const postuploadDataError = (erordata) => {
  //   return {
  //     type: BULK_UPLOAD_ERROR,
  //     payload: erordata,
  //   };
  // };
  export const getDrawingBysite = (params, download,exportname) => {
    return {
      type: DRAWING_DATA,
      payload: params,
      exports: download,
      exportname:exportname
    };
  };
  
  export const drawinglistbysiteSucess = (response) => {
    return {
      type: DRAWING_DATA_SUCCESS,
      payload: response,

    };
  };
  export const drawinglistbysiteError = (erordata) => {
    return {
      type: DRAWING_DATA_ERROR,
      payload: erordata,
    };
  };

  export const getChangeRequestBysite = (params, download,exportname) => {

    return {
      type: CHANGEREQUEST_BY_SITEID,
      payload: params,
      exports: download,
      exportname:exportname
    };
  };
  
  export const ChangeRequestListSuccess = (response) => {
    return {
      type: CHANGEREQUEST_BY_SITEID_SUCCESS,
      payload: response,

    };
  };
  export const ChangeRequestError = (erordata) => {
    return {
      type: CHANGEREQUEST_BY_SITEID_ERROR,
      payload: erordata,
    };
  };

  export const onAddnewChangeRequest = (params, callback) => {
    return {
      type: ADD_CHANGEREQUEST,
      payload: params,
      callback,
    };
  };
  export const onAddnewChangeRequestSuccess = (response) => {
    
    return {
      type: ADD_CHANGEREQUEST_SUCCESS,
      payload: response,
    };
  };
  export const onAddnewChangeRequestError = (erordata) => {
    return {
      type: ADD_CHANGEREQUEST_ERROR,
      payload: erordata,
    };
  };
  
